export default "__VITE_ASSET__9zR9nhJF__"